import { Box, CircularProgress, Paper, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import { CancelOriginalPlan, fetchPaymentStatus } from '../api/payment';
import { findOriginalPlan } from '../api/user';

const Complete = () => {
  const [linkage, setLinkage] = useState('');
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const status = location.state?.status || 'payment';

  useEffect(() => {
    const handlePayment = async () => {
      const sessionId = searchParams.get('session_id');
      if (!sessionId) {
        console.error('session_id がURLに存在しません');
        return;
      }

      try {
        // 支払い情報取得
        const data = await fetchPaymentStatus(sessionId);
        const priceId = data.price_id || '';
        const campaignCode = data.campaign_code || '';
        const linkage = data.linkage_identifier || ''; // 決済番号のみ
        const memberId = data.member_id || ''; // 会員IDを取得

        setLinkage(linkage);

        // 会員IDが存在する場合、連結
        const finalLinkageIdentifier = (memberId && memberId !== 'null')
          ? `${linkage}@@@${memberId}` 
          : linkage;

        const res = await findOriginalPlan(priceId);
        const originalPlan = res.original_plan;

        if(originalPlan?.plan?.upgrade_type === 2){
          await CancelOriginalPlan(priceId);
        }

        // docomo連携用POSTフォーム作成
        const baseUrl = process.env.REACT_APP_REDIRECT_URL;
        const form = document.createElement('form');
        form.method = 'POST';
        form.action = baseUrl;

        form.style.display = 'none';

        const campaignInput = document.createElement('input');
        campaignInput.type = 'hidden';
        campaignInput.name = 'campaign_code';
        campaignInput.value = campaignCode;

        const linkageInput = document.createElement('input');
        linkageInput.type = 'hidden';
        linkageInput.name = 'linkage_identifier';
        linkageInput.value = finalLinkageIdentifier;

        form.appendChild(campaignInput);
        form.appendChild(linkageInput);
        document.body.appendChild(form);

        console.log('3秒後にシリアルコード配布サイトへ遷移します');

        const timer = setTimeout(() => {
          form.submit();
        }, 3000);

        return () => clearTimeout(timer);
      } catch (err) {
        console.error('API取得エラー:', err);
      }
    };

    handlePayment();
  }, [searchParams]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        textAlign: 'center',
        padding: 3,
      }}
    >
      <Paper
        elevation={3}
        sx={{
          p: 5,
          maxWidth: 500,
          width: '100%',
          borderRadius: 2,
        }}
      >
        <Typography variant="h4" color="success.main">
          {status === 'cancel' ? '解約完了しました。' : '決済完了しました。'}
        </Typography>

        <Box sx={{ my: 3, overflowWrap: 'break-word' }}>
          {linkage && (
            <Typography variant="body1">
              決済番号: {linkage}
            </Typography>
          )}
        </Box>

        <Box sx={{ mt: 3 }}>
          <CircularProgress size={40} sx={{ mb: 2 }} />
          <Typography variant="body1" color="text.secondary">
            3秒後にシリアルコード配布サイトへ遷移します...
          </Typography>
        </Box>
      </Paper>
    </Box>
  );
};

export default Complete;
